import React from 'react'
import { ChatbotTable } from '@components/teachV2/ChatbotMonitoring'

export default function ChatbotMonitoringPage() {
  return (
    <div className="wrapper -chatbotPage">
      <ChatbotTable />
    </div>
  )
}
